<template>
  <div class="order-page-stats">
    <div class="info-board">
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[ShipmentWorking] }} Ships</span>
          <span class="sub-title">{{ ShipmentWorking }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[ShipmentShipping] }} Ships</span>
          <span class="sub-title">{{ ShipmentShipping }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[ShipmentDelivered] }} Ships</span>
          <span class="sub-title">{{ ShipmentDelivered }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ShipmentWorking,
  ShipmentShipping,
  ShipmentDelivered
} from '@/core/models/shipment'
import { queryShipment } from '@/api/shipment'
export default {
  name: 'ShipmentPageStats',
  data() {
    return {
      ShipmentWorking,
      ShipmentShipping,
      ShipmentDelivered,
      counts: {
        [ShipmentWorking]: 999,
        [ShipmentShipping]: 999,
        [ShipmentDelivered]: 999
      }
    }
  },
  mounted() {
    this.countShipments(ShipmentWorking)
    this.countShipments(ShipmentShipping)
    this.countShipments(ShipmentDelivered)
  },
  methods: {
    countShipments(status) {
      queryShipment({
        statusList: [status],
        size: 0
      }).then(res => {
        this.counts[status] = res.total
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.info-board {
  gap: 20px;
  flex-wrap: wrap;

  .stats-info-card {
    pointer-events: none;
    min-width: 160px !important;

    .info-card-left {
      .title {
        font-size: 30px;
        font-family: 'oswald bold', sans-serif;
      }

      .sub-title {
        margin-top: 5px;
        font-size: 24px;
        font-family: 'oswald light', sans-serif;
      }
    }
  }

  @extend .global-margin;
  @extend .f-r-vc;
}
</style>
